import type { TFunction } from 'i18next';
import styles from './ReservationBoardCalendar.module.css';

type RsCalendarDraftCardProps = {
  timeLabel: string;
  nameLabel: string;
  overlaps: boolean;
  t: TFunction;
};

/** カレンダー上の登録前プレビュー（下書き）カード */
export default function RsCalendarDraftCard({
  timeLabel,
  nameLabel,
  overlaps,
  t,
}: RsCalendarDraftCardProps) {
  return (
    <div
      className={`${styles.bookingItem} ${styles.bookingDraftItem}${
        overlaps ? ` ${styles.bookingDraftItemConflict}` : ''
      }`}
      aria-hidden
    >
      <div className={styles.bookingMainRow}>
        <span className={styles.bookingTime}>{timeLabel}</span>
        {nameLabel ? <span className={styles.bookingLabel}>{nameLabel}</span> : null}
      </div>
      <div className={styles.bookingDraftBadge}>
        {overlaps
          ? t('reservation.board.draftBadgeOverlap', { defaultValue: '重複' })
          : t('reservation.board.draftBadge', { defaultValue: '登録前' })}
      </div>
    </div>
  );
}
